// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.d-flex[data-v-b1ab27d6] {\r\n  flex-wrap: wrap;\n}\n.order-img[data-v-b1ab27d6] {\r\n  width: 80px;\r\n  height: 80px;\r\n  object-fit: cover;\n}\n[dir] .order-img[data-v-b1ab27d6] {\r\n  border-radius: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
